<template>
	<v-combobox
		v-model="model"
		:items="items"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		item-text="name"
		item-value="id"
		:hide-details="hideDetails"
		:clearable="clearable"
		:loading="loading"
		:rules="rules"
		return-object
	></v-combobox>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
export default {
	mixins: [mixin],
	props: {
		state:	{ type: [Object, String], default: null },
	},
	watch: {
		state(item) {
			if(item !== null && typeof item === 'object') {
				this.onRefresh(item)
				this.model = null
			}
		},
	},
	computed: {
		...mapGetters('City', [ 'items' ]),
	},
	methods: {
		...mapActions('City', [ 'load', 'setItems' ]),

		onLoad() {
			if(this.state) {
				this.loading = true;
				this.load({state: this.state}).then(() => {
					this.setDefault();
				}).finally(() => (this.loading = false));
			}
		},
	},
}
</script>